const isCompany = kind => kind === 'C'

export default isCompany

